module.exports = __webpack_public_path__ + "94c96967794f5f76bf0321b237003f7c.fbx";